import {
  Certificate,
  CertificateRepresentation,
} from "../infrastructure/api/api";

export const CERTIFICATE_STATUSES = [
  "revoked",
  "unregistered",
  "expired",
  "active",
] as const;

export type CertificateStatus = (typeof CERTIFICATE_STATUSES)[number];

export interface CertificateStatusInfo {
  certStatus: CertificateStatus;
  isActive: boolean;
  isRevokedOrUnregistered: boolean;
  isExpired: boolean;
}

const hasExpired = (notAfter: string): boolean => {
  const expiry = new Date(notAfter).getTime();

  return Number.isNaN(expiry) || expiry < Date.now();
};

const certificateStatus = (cert: Certificate): CertificateStatusInfo => {
  const isRevokedOrUnregistered = cert.revoked || cert.unregisteredAt !== null;
  const isExpired = hasExpired(cert.notAfter);

  const status: CertificateStatus = cert.revoked
    ? "revoked"
    : cert.unregisteredAt !== null
      ? "unregistered"
      : isExpired
        ? "expired"
        : "active";

  return {
    certStatus: status,
    isActive: status === "active",
    isRevokedOrUnregistered,
    isExpired,
  };
};

export const statusOf = (
  representation: CertificateRepresentation,
): CertificateStatusInfo => certificateStatus(representation.certificate);
